import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as n } from "react";
const r = ({
  title: o,
  titleId: l,
  ...i
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": l,
    ...i,
    children: [
      o ? /* @__PURE__ */ e.jsx("title", { id: l, children: o }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M511.96 42.668c-201.55 0-365.042 147.136-365.042 328.532 0 246.4 365.042 610.132 365.042 610.132S877.002 617.6 877.002 371.2c0-181.396-163.482-328.532-365.042-328.532m0 469.332c-67.166 0-121.682-52.563-121.682-117.331s54.516-117.331 121.682-117.331 121.682 52.563 121.682 117.331S579.126 512 511.96 512",
          clipRule: "evenodd"
        }
      )
    ]
  }
), t = n(r);
export {
  t as default
};
